import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../redux/actions/user'

/**
 * Custom React hook for making API queries and handling loading and error states.
 *
 * @param {string} query - The API query to be executed.
 * @returns {{ data: any, isLoading: boolean, error: Error | null }} An object containing the query response data, a loading indicator, and any potential error.
 */
export function useQuery(query) {

  const dispatch = useDispatch()

  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  const [data, setData] = useState(undefined)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)


  useEffect(async () => {

    setIsLoading(true)
    const { json, err } = await allActions.fetchGetAPI(query, dispatch, token)

    if (err) {
      setError(err)
      return enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
    }

    if (json.err) {
      setError(json.err)
      return enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
    }

    setData(json)
    setIsLoading(false)
  }, [query, dispatch, token])


  return { data, isLoading, error }
}

export function transformFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}
